export default __webpack_public_path__ + "static/media/PsychologyClinic.6b7d5459.png";